export default {
  cartLabel: {
    en: 'Shopping cart',
  },
}
